import { render } from "./CreateReservation.vue?vue&type=template&id=a677f20c"
import script from "./CreateReservation.vue?vue&type=script&lang=ts"
export * from "./CreateReservation.vue?vue&type=script&lang=ts"
script.render = render

export default script